import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import App from "./App";
import { initSentry, SentryErrorBoundary } from "./lib/sentry";
import { initGtag } from "./lib/gtag";
import "./index.css";

initSentry();
initGtag();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
    },
  },
});

function ErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 text-center">
      <div className="max-w-md space-y-3">
        <h1 className="text-2xl font-bold">Something went wrong.</h1>
        <p className="text-neutral-600">
          We've been notified. Try refreshing the page — if the problem persists, get in touch.
        </p>
        <button
          onClick={() => location.reload()}
          className="rounded-lg bg-brand text-white px-5 py-2.5 font-medium hover:bg-brand-700 transition"
        >
          Reload
        </button>
      </div>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={<ErrorFallback />} showDialog={false}>
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster richColors position="top-right" />
      </QueryClientProvider>
    </SentryErrorBoundary>
  </React.StrictMode>,
);
